import { render, staticRenderFns } from "./SidebarServicoIdoso.vue?vue&type=template&id=7e2b560e"
import script from "./SidebarServicoIdoso.vue?vue&type=script&lang=js"
export * from "./SidebarServicoIdoso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports